import { useContext } from "react";
import { ThemeContext } from "styled-components";
import { getNumberFromPx } from "../../../common-deprecated/themes/common";
import { useWindowDimensionsContext } from "../../../common-deprecated/containers/WindowDimensionsProvider";

export enum CtaTarget {
    Mobile = "mobile",
    Default = "default",
}

// Small helper hook for determining which cta config should be used (desktop / mobile).
export const useCtaTarget = (): CtaTarget => {
    const windowWidth = useWindowDimensionsContext().width;
    const { breakpoints } = useContext(ThemeContext);
    return windowWidth && windowWidth < getNumberFromPx(breakpoints.md) ? CtaTarget.Mobile : CtaTarget.Default;
};
